import { idToString, convertMonetaryValueToNumber, toInt } from '../util';

export const getViewEventName = ({ formatCode, categoryCode, type } = {}) => {
  const eventName = [formatCode, categoryCode, type]
    .filter((str) => str)
    .map((str) => str.toUpperCase())
    .join('_');
  return `VIEW_${eventName}`;
};

export const getPayloadAndEventNameForFormatView = (data) => {
  const { pageDepth, formatId, formatCode } = data;
  const payload = {
    page_depth: pageDepth,
    format_id: toInt(formatId),
    format_code: formatCode,
  };
  const eventName = getViewEventName({ formatCode, type: 'FORMAT' });
  return { payload, eventName };
};

export const getPayloadAndEventNameForCategoryView = (data) => {
  const { categoryId, categoryCode, formatId, formatCode, pageDepth } = data;
  const payload = {
    category_id: toInt(categoryId),
    category_code: categoryCode,
    format_id: toInt(formatId),
    format_code: formatCode,
    page_depth: pageDepth,
  };
  const eventName = getViewEventName({ formatCode, categoryCode, type: 'CATEGORY' });
  return { payload, eventName };
};

export const getPayloadAndEventNameForCourseView = (data) => {
  const {
    id,
    title,
    publicTitle,
    originCourseId,
    formatId,
    formatCode,
    categoryId,
    categoryCode,
    page,
    products,
    product: defaultProduct,
  } = data;

  const product = defaultProduct || (products && Array.isArray(products) && products[0]) || {};

  const payload = {
    course_id: toInt(id),
    course_title: publicTitle || title,
    origin_course_id: toInt(originCourseId),
    format_id: toInt(formatId),
    format_code: formatCode,
    category_id: toInt(categoryId),
    category_code: categoryCode,
    page_id: toInt(page.id),
    page_title: page.title,
    page_depth: '3depth',
    list_price: product.listPrice,
    sale_price: product.salePrice,
  };
  const eventName = getViewEventName({ formatCode, categoryCode, type: 'COURSE' });
  return { payload, eventName };
};

const getPayloadForEnrollmentAndOrderWithEventName = ({ data, eventName }) => {
  const { product, courses, bundle, customerId } = data;
  const payload = {
    product_id: product.id,
    product_title: product.publicTitle || product.title,
    product_type: product.type,
    sale_price: convertMonetaryValueToNumber(product.salePrice),
  };
  if (product.type === 'COURSE' && courses.length) {
    const course = courses[0];
    payload['course_id'] = course.id;
    payload['course_title'] = course.publicTitle || course.title;
    payload['origin_course_id'] = course.originCourseId;
    payload['format_id'] = course.formatId;
    payload['format_code'] = course.format.code;
    payload['category_id'] = course.categoryId;
    payload['category_code'] = course.category.code;
  }
  return { payload, eventName };
};

export const getPayloadAndEventNameForEnrollmentView = (data) =>
  getPayloadForEnrollmentAndOrderWithEventName({ data, eventName: 'VIEW_ENROLLMENT_PAGE' });

export const getPayloadAndEventNameForTransactionOrder = (data) =>
  getPayloadForEnrollmentAndOrderWithEventName({ data, eventName: 'VIEW_PURCHASE_PAGE' });

export const getPayloadAndEventNameForTransactionPayment = (data) => {
  const { productSaleInfo, transactionInfo } = data;
  const { product, courses } = productSaleInfo;
  const { transaction, coupons } = transactionInfo;

  const coupon = (coupons && coupons[0]) || {};

  const payload = {
    product_id: product.id,
    product_title: product.publicTitle || product.title,
    product_type: product.type,
    sale_price: product.salePrice,
    quantity: transaction.quantity || 1,
    revenue: transaction.amount,
    $price: product.salePrice,
    $quantity: transaction.quantity || 1,
    $revenue: transaction.amount,
    coupon_id: coupon.id,
    coupon_title: coupon.publicTitle || coupon.title,
    discount_amount: coupon.discountAmount,
    method: transaction.method,
  };
  if (product.type === 'COURSE' && courses.length) {
    const course = courses[0];
    payload['course_id'] = course.id;
    payload['course_title'] = course.publicTitle || course.title;
    payload['origin_course_id'] = course.originCourseId || '';
    payload['format_id'] = course.formatId;
    payload['format_code'] = course.format.code;
    payload['category_id'] = course.categoryId;
    payload['category_code'] = course.category.code;
  }
  const eventName = 'COMPLETE_PURCHASE';
  return { payload, eventName };
};

const userPropertyType = {
  ADD: { methodName: 'add', valueArrayName: 'adds' },
  APPEND: { methodName: 'append', valueArrayName: 'appends' },
  SET: { methodName: 'set', valueArrayName: 'sets' },
  SET_ONCE: { methodName: 'setOnce', valueArrayName: 'setOnces' },
};

export const setUserProperty = ({ amplitude, data }) => {
  Object.values(userPropertyType).forEach((type) => {
    if (data[type.valueArrayName] && Array.isArray(data[type.valueArrayName]))
      data[type.valueArrayName].forEach(({ key, value }) =>
        amplitude.identify(new amplitude.Identify()[type.methodName](key, value))
      );
  });
};
